import { ADD_TO_CART, DECREMENT_ITEM, INCREMENT_ITEM } from "./actionTypes";

export const addToCart = (productId) => {
  return {
    type: ADD_TO_CART,
    payload: {
      id: productId,
    },
  };
};
export const incrementItemQuantity = (productId) => {
  return {
    type: INCREMENT_ITEM,
    payload: {
      id: productId,
    },
  };
};
export const decrementItemQuantity = (productId) => {
  return {
    type: DECREMENT_ITEM,
    payload: {
      id: productId,
    },
  };
};
